import { buildProps as p, definePropType as e } from "./index601.js";
import { componentSizes as r } from "./index684.js";
import { mutable as t } from "./index612.js";
const n = p({
  pageSize: {
    type: Number,
    required: !0
  },
  pageSizes: {
    type: e(Array),
    default: () => t([10, 20, 30, 40, 50, 100])
  },
  popperClass: {
    type: String
  },
  popperStyle: {
    type: e([String, Object])
  },
  disabled: Boolean,
  teleported: Boolean,
  size: {
    type: String,
    values: r
  },
  appendSizeTo: String
});
export {
  n as paginationSizesProps
};
